const fileSizeUnits=['Bytes','KB','MB','GB']

export function getReadableFileSize (bytes=0) {
    let unitIndex=0
    while(bytes>1024){
        unitIndex++
        bytes/=1024
    }
    return `${bytes}${fileSizeUnits[unitIndex]}`
}